import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, {InputLabel} from "material-ui/Input";
import {MenuItem} from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, {Tab} from "material-ui/Tabs";
import _ from "lodash";
import moment from "moment";
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import DatePicker from 'material-ui-pickers/DatePicker';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import {
  FormControl, FormHelperText, FormControlLabel,
} from "material-ui/Form";
import {withStyles} from "material-ui/styles";
import styles from "./styles";
import {ModalHeader, ModalContents, ModalFooter} from "../../common/modal";
import {connect} from "react-redux";
import {
  getCustomer,
} from "../../../redux/actions";
import {compose} from "recompose";
import BatteryStatement from "./BatteryStatement";
import {getDateFormat} from "../../../common/utils";

class NewDeviceRma extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      errors: {},
      tabs: [props.translate("tab_details"), props.translate("device_rma_battery_agreement")],
      tabPosition: 0,
      rma: {
        deviceId: "",
        deviceType: "",
        customerName: "",
        contactFirstName: "",
        contactLastName: "",
        telephoneNo: "",
        email: "",
        calibrationDueDate: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        reason: "",
        acceptedBatteryStatement: false,
      },
      reasons: [
        { label: "device_rma_reason_calibration", value: "Calibration" },
        { label: "device_rma_reason_repair", value: "Repair" },
      ],
      modalError: null,
      customer: null,
      modalRef: React.createRef()
    };
  }

  componentDidMount() {
    const {device, getCustomer} = this.props;

    const calibrationDueDate = device.calibrationdue ? moment.utc(device.calibrationdue).local().format("YYYY-MM-DD") : "";
    const rma = {
      ...this.state.rma,
      deviceId: device.deviceserialno,
      deviceType: device.systemdevicetype,
      calibrationDueDate: calibrationDueDate
    }
    this.setState({rma: rma});

    getCustomer(device.organisationId);
  }

  componentDidUpdate(prevProps, prevState) {
    const {customer} = this.props;

    if (!_.isEqual(prevState.customer, customer)) {
      const rma = {
        ...this.state.rma,
        customerName: customer.name,
        contactFirstName: customer.contactfirstname,
        contactLastName: customer.contactlastname,
        telephoneNo: customer.telephoneno,
        email: customer.contactemail,
        address: customer.address,
        city: customer.city,
        state: customer.state,
        country: customer.country,
        zipCode: customer.zipcode
      };
      this.setState({rma: rma, customer: customer});
    }
  }

  handleTabChange = (event, value) => {
    let validate = this.validate();
    let {tabPosition} = this.state;
    if (validate || tabPosition - 1 >= 0) this.setState({tabPosition: value});
  };

  tabNext() {
    let check = this.canTabNext();
    let validate = this.validate();
    if (validate && check.can) this.setState({tabPosition: check.pos});
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    let check = this.canTabBack();
    let validate = this.validate();
    if (check.can) this.setState({tabPosition: check.pos});
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const {tabs, tabPosition} = this.state;
    let pos = tabPosition + 1;
    return pos < tabs.length ? {can: true, pos: pos} : false;
  }

  canTabBack() {
    const {tabPosition} = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? {can: true, pos: pos} : false;
  }

  tabsComplete() {
    const {tabs, tabPosition} = this.state;
    return tabPosition === tabs.length - 1;
  }

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.close();
  };

  onChangeField(name, value) {
    let rma = {...this.state.rma};
    rma[name] = value;
    let errors = {...this.state.errors};
    errors = {
      ...errors, [name]: false
    };
    this.setState({rma, errors});
  }

  onChange = e => {
    this.onChangeField(e.target.name, e.target.value);
  }

  onCheckboxChange = e => {
    this.onChangeField(e.target.name, e.target.checked);
  }

  validate = () => {
    const {rma, tabPosition} = this.state;
    const {translate} = this.props;
    let errors = {};

    switch (tabPosition) {
      case 0:
        const enterValueFields = ["customerName", "contactFirstName",
          "contactLastName", "telephoneNo", "email", "deviceId", "deviceType"];
        const enterValueError = translate("error_enter_value");
        const selectValueFields = ["reason"];
        const selectValueError = translate("error_select_value");

        enterValueFields.forEach(field => {
          if (rma[field] === undefined || rma[field] === null || rma[field].trim() === "") {
            errors[field] = enterValueError;
          }
        });
        selectValueFields.forEach(field => {
          if (rma[field] === undefined || rma[field] === null || rma[field].trim() === "") {
            errors[field] = selectValueError;
          }
        });
        break;
      case 1:
        if (!rma.acceptedBatteryStatement) {
          errors.acceptedBatteryStatement = translate("error_check_box");
        }
        break;
      default:
        return true;
    }

    if (Object.keys(errors).length) {
      this.setState({errors});
      return false;
    } else {
      return true;
    }
  };

  onSubmit() {
    let {rma} = this.state;

    if (!this.validate()) {
      return;
    }

    this.props.submit(rma);
  }

  render() {
    const {
      classes, translate,
    } = this.props;

    const locale = window.localStorage.language || 'en-GB';
    const dateFormat = getDateFormat(locale);

    const {
      rma,
      errors,
      tabs,
      tabPosition,
      modalError,
      modalRef,
      reasons,
    } = this.state;

    return (<Modal open={this.state.open} onClose={this.handleClose}>
      <div className={classes.root}>
        <Paper className={classes.modal}>
          <ModalHeader>
            <Typography
              type="headline"
              color="inherit"
              className={classes.modalHeader}
            >
              {translate("device_details_request_service")}
            </Typography>
            <Button className={classes.close} onClick={this.handleClose}>
              <Icon>clear</Icon>
            </Button>
          </ModalHeader>

          <ModalContents>
            {modalError && (<Paper className={classes.error} elevation={0}>
              <Typography component="p" color="secondary">
                {modalError}
              </Typography>
            </Paper>)}

            <form noValidate autoComplete="off" className={classes.form}
                  ref={modalRef}>
              <Tabs value={tabPosition} onChange={this.handleTabChange}>
                {tabs.map((tab, index) => {
                  return <Tab key={index} label={tab}/>;
                })}
              </Tabs>

              {tabPosition === 0 && (<div className={classes.summary}>
                <TextField
                  error={!!errors.customerName}
                  required
                  name="customerName"
                  label={translate("organisation_name")}
                  margin="normal"
                  fullWidth
                  value={rma.customerName}
                  onChange={this.onChange}
                  helperText={errors.customerName}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.contactFirstName}
                  required
                  name="contactFirstName"
                  label={translate("contactfirstname")}
                  margin="normal"
                  fullWidth
                  value={rma.contactFirstName}
                  onChange={this.onChange}
                  helperText={errors.contactFirstName}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.contactLastName}
                  required
                  name="contactLastName"
                  label={translate("contactlastname")}
                  margin="normal"
                  fullWidth
                  value={rma.contactLastName}
                  onChange={this.onChange}
                  helperText={errors.contactLastName}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.telephoneNo}
                  required
                  name="telephoneNo"
                  label={translate("telephoneno")}
                  margin="normal"
                  fullWidth
                  value={rma.telephoneNo}
                  onChange={this.onChange}
                  helperText={errors.telephoneNo}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.email}
                  required
                  name="email"
                  label={translate("email")}
                  margin="normal"
                  fullWidth
                  value={rma.email}
                  onChange={this.onChange}
                  helperText={errors.email}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.deviceId}
                  required
                  name="deviceId"
                  label={translate("device_details_device_id")}
                  margin="normal"
                  fullWidth
                  value={rma.deviceId}
                  onChange={this.onChange}
                  helperText={errors.deviceId}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.deviceType}
                  required
                  name="deviceType"
                  label={translate("job_device_help")}
                  margin="normal"
                  fullWidth
                  value={rma.deviceType}
                  onChange={this.onChange}
                  helperText={errors.deviceType}
                  className={classes.textField}
                />

                <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                  <DatePicker
                    error={!!errors.calibrationDueDate}
                    name="calibrationDueDate"
                    label={translate('device_details_calibration_due_date')}
                    margin="normal"
                    fullWidth
                    value={rma.calibrationDueDate ? moment(rma.calibrationDueDate) : null}
                    helperText={errors.calibrationDueDate}
                    className={classes.textField}
                    format={dateFormat}
                    onChange={() => {}}
                    disabled
                  />
                </MuiPickersUtilsProvider>

                <TextField
                  error={!!errors.address}
                  name="address"
                  label={translate("customer_address")}
                  margin="normal"
                  fullWidth
                  value={rma.address}
                  onChange={this.onChange}
                  helperText={errors.address ? errors.address : translate("customer_address_help")}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.city}
                  name="city"
                  label={translate("customer_city")}
                  margin="normal"
                  fullWidth
                  value={rma.city}
                  onChange={this.onChange}
                  helperText={errors.city ? errors.city : translate("customer_city_help")}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.state}
                  name="state"
                  label={translate("customer_state_county")}
                  margin="normal"
                  fullWidth
                  value={rma.state}
                  onChange={this.onChange}
                  helperText={errors.state ? errors.state : translate("customer_state_county_help")}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.country}
                  name="country"
                  label={translate("customer_country")}
                  margin="normal"
                  fullWidth
                  value={rma.country}
                  onChange={this.onChange}
                  helperText={errors.country ? errors.country : translate("customer_country_help")}
                  className={classes.textField}
                />

                <TextField
                  error={!!errors.zipCode}
                  name="zipCode"
                  label={translate("customer_zipcode")}
                  margin="normal"
                  fullWidth
                  value={rma.zipCode}
                  onChange={this.onChange}
                  helperText={errors.zipCode ? errors.zipCode : translate("customer_zipcode_help")}
                  className={classes.textField}
                />

                <FormControl
                  className={classes.textField}
                  margin="normal"
                  error={!!errors.reason}
                >
                  <InputLabel htmlFor="reason" required>
                    {translate("device_rma_reason")}
                  </InputLabel>
                  <Select
                    value={rma.reason}
                    onChange={this.onChange}
                    input={<Input
                      name="reason"
                      id="reason"
                      value={rma.reason}
                    />}
                    fullWidth
                  >
                    {reasons ? reasons
                      .map((reason, index) => {
                        return (<MenuItem key={index} value={reason.value}>
                          {translate(reason.label)}
                        </MenuItem>);
                      }) : null}
                  </Select>
                  <FormHelperText>
                    {errors.reason}
                  </FormHelperText>
                </FormControl>

              </div>)}

              {tabPosition === 1 && (<div className={classes.summary}>
                <BatteryStatement />
                <FormControl margin="none" fullWidth
                             error={!!errors.acceptedBatteryStatement}>
                  <FormControlLabel
                    margin="normal"
                    control={<Checkbox
                      name="acceptedBatteryStatement"
                      checked={rma.acceptedBatteryStatement}
                      onChange={this.onCheckboxChange}
                      value="marginincluded"
                    />}
                    label={translate("device_rma_accept_battery_agreement")}
                  />
                  <FormHelperText>
                    {errors.acceptedBatteryStatement}
                  </FormHelperText>
                </FormControl>
              </div>)}
            </form>
          </ModalContents>

          <ModalFooter classes={classes}>
            <Button
              raised
              className={classes.button}
              onClick={() => this.tabBack()}
              disabled={!this.canTabBack().can}
            >
              <Icon>navigate_before</Icon>
            </Button>

            <Button
              raised
              className={classes.button}
              onClick={() => this.tabNext()}
              disabled={!this.canTabNext().can}
            >
              <Icon>navigate_next</Icon>
            </Button>

            {this.tabsComplete() ? (<Button
              raised
              className={classes.submit}
              onClick={() => this.onSubmit()}
              type="submit"
            >
              {translate("general_submit")}
            </Button>) : null}
          </ModalFooter>
        </Paper>
      </div>
    </Modal>);
  }
}

const mapStateToProps = (state) => ({
  customer: state.customerReducer.customer, ...state,
});

const mapDispatchToProps = (dispatch, props) => ({
  getCustomer: cid => {
    dispatch(getCustomer(cid));
  },
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(NewDeviceRma);
